import {
  NahlasenieChybyEnum as NahlasenieChybyEnumGenerated,
  NotificationNahlasenieChyby,
  NotificationNahlasenieChybyApi,
} from 'evidencna-aplikacia-frontend-ts-axios';
import { ClientResponse } from '../../../model/ClientResponse';
import apiConfiguration from '../../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../../configuration/apiConfigurationConstants';
import NahlasenieChybyRequest from '../../../model/NahlasenieChybyRequest';
import { NahlasenieChybyEnum } from '../../../constants/NahlasenieChybyEnum';

const client = new NotificationNahlasenieChybyApi(apiConfiguration(evidenciaPrefixPath));

const mapToNahlasenieChybyRequest = (request: NahlasenieChybyRequest): NotificationNahlasenieChyby => (
  {
    oblast: mapNahlasenieChybyEnum(request.oblast),
    popisChyby: request.popisChyby,
    email: request.email,
  }
);

const mapNahlasenieChybyEnum = (oblast: NahlasenieChybyEnum): NahlasenieChybyEnumGenerated => {
  switch (oblast) {
    case NahlasenieChybyEnum.EZBIERKA: return NahlasenieChybyEnumGenerated.Ezbierka;
    case NahlasenieChybyEnum.ELEGISLATIVA: return NahlasenieChybyEnumGenerated.Elegislativa;
    case NahlasenieChybyEnum.VYKONAVACIE_PREDPISY: return NahlasenieChybyEnumGenerated.VykonavaciePredpisy;
    case NahlasenieChybyEnum.TEZAURY: return NahlasenieChybyEnumGenerated.Tezaury;
    case NahlasenieChybyEnum.PRAVO_EU: return NahlasenieChybyEnumGenerated.PravoEu;
    case NahlasenieChybyEnum.JUDIKATY: return NahlasenieChybyEnumGenerated.Judikaty;
    case NahlasenieChybyEnum.REGISTRACIA: return NahlasenieChybyEnumGenerated.Registracia;
    case NahlasenieChybyEnum.INE: return NahlasenieChybyEnumGenerated.Ine;
    default:
      return NahlasenieChybyEnumGenerated.Ine;
  }
};

// eslint-disable-next-line import/prefer-default-export
export const postNahlasenieChybyNotification = async (
  request: NahlasenieChybyRequest,
):
  Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.sendNotificationNahlasenieChyby(mapToNahlasenieChybyRequest(request));
  return {
    responseCode: status,
  };
};
